import type { LoadingType } from "@/types";
import type { Ref } from "vue";

export default async (status: Ref<LoadingType>) => {
  if (status.value === "loaded") {
    return Promise.resolve();
  }

  return new Promise<void>((resolve) => {
    const interval = setInterval(() => {
      if (status.value === "loaded") {
        clearInterval(interval);
        resolve();
      }
    }, 50);
  });
};
